<template>
	<div class="mm-page-main">后台首页</div>
</template>

<script>

	export default {
		data() {
			return {
				
			};
		},
		created() {
		}
		
		
	};
</script>
